<div mat-dialog-title class="cust-modal-title">
  <h2 class="m-0">Point conversion</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div class="conversion-row">
    <!-- Wallet Cash -->
    <h4 class="rerd_heading">
      1 Wallet cash equivalent to:
    </h4>

    <mat-form-field appearance="outline" class="conversion-field">
      <mat-label>Point(s)</mat-label>
      <input
        matInput
        type="number"
        [(ngModel)]="pointCoversionRate"
        smDecimalOnly
      />
    </mat-form-field>

    <!-- Reward Points -->
    <h4 class="rerd_heading">Rewards point(s)</h4>
  </div>

  <div class="peod_checkopen">
    <p>
      Here you can decide the value of Reward Points. Customers and members will
      convert their Reward Points into Wallet Cash which they can utilize in
      payments for services, membership and purchase.
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button (click)="onsave()" style="color: #fff" mat-flat-button color="accent">
    Save
  </button>
</mat-dialog-actions>
